import React, { Component } from "react"
import "../../css/Register.css"
import { Button, Icon } from "semantic-ui-react"

//component
import {
	correctBox,
	warningpassword
} from "../Function/WarningPassword.function"
import Tooltip from "../../components/Tooltip"
import TermandPrivacy from "./TermandPrivacy"
import ButtonSignupMaterial from "./ButtonSignupMaterial"

//material ui
import Avatar from "@material-ui/core/Avatar"
import FormControl from "@material-ui/core/FormControl"
import TextField from "@material-ui/core/TextField"
import AccountBoxIcon from "@material-ui/icons/AccountBox"
import Typography from "@material-ui/core/Typography"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Checkbox from "@material-ui/core/Checkbox"
import CircularProgress from "@material-ui/core/CircularProgress"
import InputAdornment from "@material-ui/core/InputAdornment"
import IconButton from "@material-ui/core/IconButton"
import Visibility from "@material-ui/icons/Visibility"
import VisibilityOff from "@material-ui/icons/VisibilityOff"
import InputLabel from "@material-ui/core/InputLabel"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import ListItemText from "@material-ui/core/ListItemText"
class RegisterForm extends Component {
	render() {
		const {
			isFocus,
			classes,
			t,
			Open,
			erroremail,
			errorpassword,
			errorre_password,
			email,
			password,
			re_password,
			given_name,
			family_name,
			researchArea,
			handleChangeresearchArea,
			MenuProps,
			options,
			value,
			accepted_news,
			finish,
			showPassword,
			handleClickClose,
			handleChange,
			handleFocus,
			inputPassword,
			handleClickShowPassword,
			handleChangecheck,
			validateForm,
			handleConfirmationSubmit,
			finishgm,
			finishfb,
			finishln,
			handleClickGM,
			handleClickFB,
			handleClickLN,
			login_gm,
			login_fb,
			login_ln,
			openTermand,
			openprivacy,
			closeprivacy,
			create_user,
			get_user,
			update_latest_login,
			history
		} = this.props
		return (
			<Dialog
				open={Open}
				onClose={handleClickClose}
				scroll="body"
				className="Signupdialog"
				PaperProps={{
					style: {
						maxWidth: "632px"
					}
				}}
			>
				<DialogContent className={classes.paper}>
					<Avatar className={classes.avatar}>
						<AccountBoxIcon />
					</Avatar>
					<Typography
						variant="h5"
						component="h3"
						style={{ fontSize: 18, fontFamily: "Roboto, sans-serif" }}
					>
						{t("NavBarDesktop.NavBarDesktopSignUp")}
					</Typography>

					<form className={classes.form}>
						<FormControl className={classes.FormControl} fullWidth>
							<Tooltip content={t("register.RegisterValidemail")}>
								<TextField
									error={erroremail}
									id="email"
									label={t("login.loginEmail")}
									placeholder={t("login.eg")}
									value={email}
									onChange={handleChange}
									autoFocus
									InputLabelProps={{
										FormLabelClasses: {
											asterisk: classes.labelAsterisk
										}
									}}
								/>
							</Tooltip>
						</FormControl>
						<div style={{ margin: "5px 0px" }} />
						{warningpassword(password, re_password)}
						<div style={{ margin: "5px 0px" }} />
						{correctBox(isFocus, password)}
						<div style={{ margin: "5px 0px" }} />
						<FormControl className={classes.FormControl} fullWidth>
							<Tooltip content={t("register.Registerpassword")}>
								<TextField
									error={errorpassword}
									type={showPassword ? "text" : "password"}
									id="password"
									label={t("login.loginPassword")}
									placeholder={t("login.loginEnterPassword")}
									value={password}
									onChange={handleChange}
									onFocus={() => handleFocus()}
									inputRef={inputPassword}
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton
													aria-label="Toggle password visibility"
													onClick={handleClickShowPassword}
												>
													{showPassword ? <VisibilityOff /> : <Visibility />}
												</IconButton>
											</InputAdornment>
										)
									}}
									InputLabelProps={{
										FormLabelClasses: {
											asterisk: classes.labelAsterisk
										}
									}}
								/>
							</Tooltip>
						</FormControl>
						<FormControl className={classes.FormControl} fullWidth>
							<TextField
								error={errorre_password}
								type="password"
								id="re_password"
								label={t("register.Registerrepassword")}
								placeholder={t("register.RegisterEnterrepassword")}
								value={re_password}
								onChange={handleChange}
								InputLabelProps={{
									FormLabelClasses: {
										asterisk: classes.labelAsterisk
									}
								}}
							/>
						</FormControl>
						<div className="row">
							<div className="col-lg-6 col-md-12 col-sm-12">
								<FormControl className={classes.FormControl} fullWidth>
									<Tooltip content={t("register.RegisterValidName")}>
										<TextField
											id="given_name"
											label={t("register.RegisterFirstName")}
											placeholder={t("register.RegisterEnterFirstName")}
											value={given_name}
											onChange={handleChange}
											InputLabelProps={{
												FormLabelClasses: {
													asterisk: classes.labelAsterisk
												}
											}}
										/>
									</Tooltip>
								</FormControl>
							</div>
							<div className="col-lg-6 col-md-12 col-sm-12">
								<FormControl className={classes.FormControl} fullWidth>
									<Tooltip content={t("register.RegisterValidName")}>
										<TextField
											id="family_name"
											label={t("register.RegisterLastName")}
											placeholder={t("register.RegisterEnterLastName")}
											value={family_name}
											onChange={handleChange}
											InputLabelProps={{
												FormLabelClasses: {
													asterisk: classes.labelAsterisk
												}
											}}
										/>
									</Tooltip>
								</FormControl>
							</div>
						</div>
						<FormControl margin="normal" fullWidth>
							<InputLabel htmlFor="age-required">
								{t("MethodSelection.ResearchArea")}
							</InputLabel>
							<Select
								required
								fullWidth
								value={researchArea}
								onChange={(e) =>
									handleChangeresearchArea(e, {
										value: e.target.value
									})
								}
								name="researchArea"
								MenuProps={MenuProps}
								className={classes.root1}
								inputProps={{
									id: "researchArea"
								}}
							>
								{options.map((items) => {
									return items.child.map((item) => {
										return item.key === "dis" ? (
											<MenuItem
												disabled
												style={{
													backgroundColor: "#eceded",
													padding: "5px 16px"
												}}
											>
												<ListItemText primary={item.value} />
											</MenuItem>
										) : (
											<MenuItem value={item.value}>
												<ListItemText
													primary={item.value}
													style={{ marginLeft: "10px" }}
												/>
											</MenuItem>
										)
									})
								})}
							</Select>
						</FormControl>
						<Typography className={classes.typographytitle}>
							By creating an account you agree to our
							<span
								style={{ color: "#1a0dab", cursor: "pointer" }}
								onClick={() => openprivacy()}
							>
								&nbsp; Terms & Privacy.{" "}
							</span>
						</Typography>
						<FormControlLabel
							style={{ display: "flex", alignItems: "center", marginBottom: 0 }}
							className={classes.FormControlLabel}
							control={
								<Checkbox
									className={classes.ckeckbox}
									checked={value}
									onChange={(event) => handleChangecheck(event, "terms")}
									color="secondary"
								/>
							}
							label={
								<Typography>
									Check here to indicate that you have read and agreed to the
									terms of the MMA Terms and Privacy.
								</Typography>
							}
						/>
						<FormControlLabel
							style={{
								display: "flex",
								alignItems: "center",
								marginBottom: 20
							}}
							className={classes.FormControlLabel}
							control={
								<Checkbox
									className={classes.ckeckbox}
									checked={accepted_news}
									onChange={(event) => handleChangecheck(event, "subscribe")}
									color="secondary"
								/>
							}
							label={<Typography>{t("register.Subscribe")}</Typography>}
						/>
						<ButtonSignupMaterial
							t={t}
							classes={classes}
							finish={finish}
							handleConfirmationSubmit={handleConfirmationSubmit}
							validateForm={validateForm}
						/>
					</form>
					<div className={classes.form}>
						<div style={{ textAlign: "center" }} className="text-divider">
							<span>OR</span>
						</div>
						<div className="row">
							<div className="col-lg-4 col-md-12 col-sm-12 buttonpartyl">
								<div className={classes.root}>
									<div className={classes.wrapper}>
										<Button
											aria-label="handleClickGM"
											disabled={finishgm}
											className="buttonsignin"
											color="google plus"
											onClick={(event) =>
												handleClickGM({
													event,
													t,
													login_gm,
													handleClickClose,
													create_user,
													get_user,
													update_latest_login,
													history
												})
											}
										>
											<Icon name="google" /> Login with Google
										</Button>
										{finishgm && (
											<CircularProgress
												size={24}
												className={classes.buttonProgress1}
											/>
										)}
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-12 col-sm-12 buttonparty">
								<div className={classes.root}>
									<div className={classes.wrapper}>
										<Button
											aria-label="handleClickFB"
											disabled={finishfb}
											className="buttonsignin"
											color="facebook"
											onClick={(event) =>
												handleClickFB({
													event,
													t,
													login_fb,
													handleClickClose,
													create_user,
													get_user,
													update_latest_login,
													history
												})
											}
										>
											<Icon name="facebook" /> Login with Facebook
										</Button>
										{finishfb && (
											<CircularProgress
												size={24}
												className={classes.buttonProgress1}
											/>
										)}
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-12 col-sm-12 buttonpartyr">
								<div className={classes.root}>
									<div className={classes.wrapper}>
										<Button
											aria-label="handleClickLN"
											disabled={finishln}
											className="buttonsignin"
											color="linkedin"
											onClick={(event) =>
												handleClickLN({
													event,
													t,
													login_ln,
													handleClickClose,
													create_user,
													get_user,
													update_latest_login,
													history
												})
											}
										>
											<Icon name="linkedin" /> Login with LinkedIn
										</Button>
										{finishln && (
											<CircularProgress
												size={24}
												className={classes.buttonProgress1}
											/>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
					<TermandPrivacy
						t={t}
						Open={openTermand}
						handleClickClose={closeprivacy}
					/>
				</DialogContent>
			</Dialog>
		)
	}
}

export default RegisterForm
